import EditPage from "../../components/EditPage";
import PageHeaderEdit from "../../components/PageHeaderEdit";
import PageInfoWContactInfoEdit from "../../components/PageInfoWContactInfoEdit";
import { UploadFolderIdProvider } from "../../util/UploadFolderIdContext";
import GalleryEdit from "../../components/GalleryEdit";

const uploadFolderId = '13gHPsZzfoHdXjNWvnbXItg10WUoEkyIC';

export default function Boern() {
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/Born">
                <PageHeaderEdit sectionKey="PageHeader" />
                <PageInfoWContactInfoEdit sectionKey="Sec1" />
                <PageInfoWContactInfoEdit sectionKey="Sec2" />
                <GalleryEdit sectionKey="Gallery" />
                <PageInfoWContactInfoEdit sectionKey="Sec3" />
                <PageInfoWContactInfoEdit sectionKey="Sec7" />
                <PageInfoWContactInfoEdit sectionKey="u2" />
            </EditPage>
        </UploadFolderIdProvider>
    );
}